module.exports = __webpack_public_path__ + "static/media/icon_request_b.814509fc.svg";